<div class="modal" #imageModal *ngIf="show && images?.length">
  <span class="close" (click)="close.emit($event)">&times;</span>
  <img class="modal-content" #imageModalImg [src]="images[0]">
  <div id="caption"></div>
</div>
